'use client'

import * as LabelPrimitive from '@radix-ui/react-label'
import * as React from 'react'

import { Label } from '@/components/ui/label'

import { cn } from '@/lib/utils'

import { FormLabel, useFormField } from '../../ui/form'


const DefaultFormLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => {
  const { formItemId } = useFormField()

  return <Label ref={ref} className={cn(className)} htmlFor={formItemId} {...props} />
})
DefaultFormLabel.displayName = 'DefaultFormLabel'

const VariantFormLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & {
    variant?: 'default' | 'error'
  }
>(({ variant = 'default', ...props }, ref) => {
  return variant === 'error' ? <FormLabel ref={ref} {...props} /> : <DefaultFormLabel ref={ref} {...props} />
})
VariantFormLabel.displayName = 'VariantFormLabel'

export { VariantFormLabel }
